"use strict";
import '/src/css/style.scss';
import Flickity from 'flickity';
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';

document.addEventListener('DOMContentLoaded', () => {

  // Splash arrow scroll
  const splashArrow = document.querySelector('.splash__arrow');
  if (splashArrow) {
    splashArrow.addEventListener('click', (e) => {
      e.preventDefault();
      const content = document.getElementById('content');
      if (content) {
        content.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  // Copy carousel
  const copyCarousel = document.querySelector('.copy__carousel');
  if (copyCarousel) {
    new Flickity(copyCarousel, {
      cellAlign: 'left',
      contain: true,
      dragThreshold: 10,
      imagesLoaded: true,
      arrowShape: {
        x0: 5,
        x1: 90,
        y1: 50,
        x2: 60,
        y2: 0,
        x3: 60
      }
    });
  }

  // Open external links in new tab
  const hostPattern = new RegExp('/' + window.location.host + '/');
  document.querySelectorAll('a').forEach((link) => {
    if (!hostPattern.test(link.href)) {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.open(link.href, '_blank');
      });
    }
  });

  // Lightbox for single images
  GLightbox({
    selector: '.lightbox',
    type: 'image'
  });

  // Gallery lightboxes
  document.querySelectorAll('.gallery').forEach((gallery, index) => {
    const galleryLinks = gallery.querySelectorAll('a');
    galleryLinks.forEach((link) => {
      link.classList.add(`glightbox-gallery-${index}`);
    });
    GLightbox({
      selector: `.glightbox-gallery-${index}`,
      type: 'image'
    });
  });

  // Project gallery carousel
  const projectImages = document.querySelectorAll('.project__image');
  if (projectImages.length > 1) {
    const galleryContainer = document.querySelector('.project__gallery .container');
    if (galleryContainer) {
      const carousel = new Flickity(galleryContainer, {
        cellSelector: '.project__image',
        cellAlign: 'center',
        contain: true,
        resize: true,
        percentPosition: true,
        setGallerySize: false,
        pageDots: true,
        wrapAround: false,
        arrowShape: {
          x0: 5,
          x1: 90,
          y1: 50,
          x2: 60,
          y2: 0,
          x3: 60
        }
      }); 

      // Video play/pause on slide change
      const projectVideo = document.querySelector('.project__image video');
      if (projectVideo) {
        projectVideo.play();
        carousel.on('select', () => {
          projectVideo.paused ? projectVideo.play() : projectVideo.pause();
        });
      }

      // Disable right-click on images
      document.querySelectorAll('.project__image img').forEach((img) => {
        img.addEventListener('mousedown', (e) => {
          if (e.button === 2) {
            e.preventDefault();
            return false;
          }
        });
      });
    }
  }

  // Standalone project video
  const projectVideoContainer = document.querySelector('.project__video video');
  if (projectVideoContainer) {
    projectVideoContainer.addEventListener('ended', () => {
      projectVideoContainer.autoplay = false;
      projectVideoContainer.load();
    });

    projectVideoContainer.addEventListener('click', () => {
      projectVideoContainer.paused ? projectVideoContainer.play() : projectVideoContainer.pause();
    });
  }

});
